export default "__VITE_ASSET__CgZul52V__"